import { makeStyles } from '@mui/styles';
import Grid from 'apollo-react/components/Grid';
import Modal from 'apollo-react/components/Modal';
import React from 'react';

import Actions from './Actions';
import * as constants from './constants';
import Criterion from './Criterion';
import { getFullColumnName } from './Criterion/utils';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { useWindowDimensions } from '../../custom-hooks/useWindowDimensions';
import { getUITA } from '../../utils/commonUtils';

const useStyles = makeStyles({
  modalProps: {
    width: '100%',
    maxWidth: constants.MAX_MODAL_WIDTH,
    '& div[class*="MuiDialogContent-root"]': {
      maxWidth: 'unset',
    },
  },
  modalResponsibleProps: {
    width: '97vw',
    maxWidth: constants.MAX_MODAL_WIDTH,
    margin: 11,
  },
  actionButtons: {
    margin: '25px 0 0 auto',
  },
});

function AdvancedSearchModal({
  onSearch,
  columns,
  criteria = [],
  viewName,
  onAddCriterion,
  onCriterionChange,
  onCriterionDelete,
  onLookup,
  ...popoverProps
}) {
  const { width } = useWindowDimensions();
  const classes = useStyles();
  const translateString = useTranslation();

  const isNeedToMakePopoverResponsible = width < constants.MAX_MODAL_WIDTH;

  const handleClose = (ev, reason) => {
    if (reason === 'escapeKeyDown' || reason === 'backdropClick') {
      ev.preventDefault();
    } else if (typeof popoverProps.onClose === 'function') {
      popoverProps.onClose();
    }
  };
  const handleSearch = () => {
    if (typeof onSearch === 'function') {
      onSearch();
    }
    if (typeof popoverProps.onClose === 'function') {
      popoverProps.onClose();
    }
  };
  const handleCriterionChange = (index) => (update) => {
    onCriterionChange(index, update);
  };
  const handleCriterionDelete = (index) => () => onCriterionDelete(index);
  const handleLookup = (index) => (column) => onLookup(column, index);

  const CustomTitle = (
    <div className={classes.title} ui-ta={getUITA('AdvancedSearch Title')}>
      {translateString('Advanced Search')}
    </div>
  );

  return (
    <Modal
      {...popoverProps}
      className={
        isNeedToMakePopoverResponsible ? classes.modalResponsibleProps : classes.modalProps
      }
      onClose={handleClose}
      hideButtons
      disableBackdropClick
      title={CustomTitle}
    >
      <Grid container>
        {criteria.map((criterion, index) => (
          <Grid key={criterion.id} item xs={12} ui-ta={getUITA('AdvancedSearch CriterionRow')}>
            <Criterion
              {...criterion}
              column={getFullColumnName(viewName, criterion?.column)}
              viewName={viewName}
              columns={columns}
              onCriterionChange={handleCriterionChange(index)}
              onLookup={handleLookup(index)}
              onDelete={handleCriterionDelete(index)}
              isFirstRow={!index}
            />
          </Grid>
        ))}
        <Grid className={classes.actionButtons} item ui-ta={getUITA('AdvancedSearch Actions')}>
          <Actions onAddCriterion={onAddCriterion} onSearch={handleSearch} />
        </Grid>
      </Grid>
    </Modal>
  );
}

export default AdvancedSearchModal;
